import { XERO_TRACKING_CATEGORY } from "constants/actionTypes";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { deserializeXeroTrackingCategory } from "lib/serializers/xeroTrackingCategories";

const xeroTrackingCategoryReducer = apiModelOfflineFetchReducer(
  XERO_TRACKING_CATEGORY,
  {
    deserializer: deserializeXeroTrackingCategory,
    clearOnRequest: false,
  },
);

export default xeroTrackingCategoryReducer;
